import { IcDataListSearch } from '@assets/icons/24x24';
import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { SearchFilterFieldName } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useIntl } from 'react-intl';

interface SearchFilterFieldProps {
  name: SearchFilterFieldName;
  label: string;
  onClick: () => void;
}

export const SearchFilterField = ({ name, label, onClick }: Readonly<SearchFilterFieldProps>) => {
  const { formatMessage } = useIntl();
  const { searchFilterFieldState } = useNotificationSearchContext();
  const selectedCount = searchFilterFieldState.selectedItemsByField[name].length;

  return (
    <HStack paddingX={2} paddingY={1.5} gap={1.5} alignItems="center" alignSelf="stretch" width="100%">
      <Text fontWeight="medium" color="neutral.300" flexGrow={1}>
        {label}
      </Text>
      <Text fontWeight="medium" color="skyBlue">
        {selectedCount || formatMessage({ id: 'global.all' })}
      </Text>
      <Button variant="pick" onClick={onClick}>
        <Icon as={IcDataListSearch} boxSize="24px" color="neutral.300" />
      </Button>
    </HStack>
  );
};
